/**
 * A class to validate if a container is empty.
 */
class ContainerEmptyValidator {
    /**
     * Constructs a new ContainerEmptyValidator instance.
     * @param {Object} model - The model to be validated.
     * @param {Object} $injector - The injector service for dependency injection.
     */
    constructor(model, $injector) {
        this.model = model;
        this.$injector = $injector;

        this._TaskDataService = null;
        this._translate = null;
        this._fetchContext = null;
        this._messageTranslateString = 'CMS.FACTORIES.MODELS.VALIDATORS.EMPTY.CONTAINER';
        this._message = null;
        this._forced_check = false;
    }

    /**
     * Retrieves the TaskDataService instance.
     * @returns {Object} The TaskDataService instance.
     */
    getTaskDataService() {
        if (!this._TaskDataService) {
            this._TaskDataService = this.$injector.get('TaskDataService');
        }
        return this._TaskDataService;
    }

    /**
     * Retrieves the translate service instance.
     * @returns {Object} The translate service instance.
     */
    getTranslateService() {
        if (!this._translate) {
            this._translate = this.$injector.get('$translate');
        }
        return this._translate;
    }

    /**
     * Retrieves the fetch context.
     * @returns {Object} The fetch context.
     */
    getFetchContext() {
        if (!this._fetchContext) {
            this._fetchContext = this.getTaskDataService().fetchContext();
        }
        return this._fetchContext;
    }

    /**
     * Validates the model.
     * @param {Object} from - The source object initiating the validation.
     * @returns {Object} The validation result.
     */
    validate(from) {
        let result = {};
        let error = false;

        if (this.model.getType() === 'sheet') {
            let containers = this.getFetchContext().findInstancesByType('container');
            for (let key in containers) {
                let container = containers[key];
                container.validate(this.model);
            }
            return result;
        }

        if (!(this.model.isShowTabs() || this.model.isShowCarousels() || this.model.isShowIaaContainer() || this.model.isShowInteraction())) {
            let parents = this.getFetchContext().getParentsEntryByUUID(this.model.getUUID());
            let sheet = parents.find(item => item.getType() === 'sheet');
            if (Object.keys(this.model.getObjects()).length === 0 && sheet) {
                error = true;
            }
        }

        result = {
            'onSheetBlur': false,
            'onlyBanner': false,
            'validator': this.getValidatorName(),
            'modelUUID': this.model.getUUID(),
            'error': error,
            'status': error ? 'DANGER' : 'SUCCESS', // WARNING | DANGER | SUCCESS
            'message': this.getErrorMessage(),
            'message_template': false,
            'callbacks': [
                'validationDisplayContainerHeadline-container-' + this.model.getUUID()
            ]
        };

        return result;
    }

    /**
     * Retrieves the error message for the validation.
     * @returns {string} The error message.
     */
    getErrorMessage() {
        let questionHeadline = this.model.getQuestionHeadline();
        this._message = this.getTranslateService().instant(this._messageTranslateString, {
            s: questionHeadline ? questionHeadline : ''
        });

        return this._message;
    }

    /**
     * Checks if the validation is forced.
     * @returns {boolean} True if the validation is forced, false otherwise.
     */
    isForcedCheck() {
        return this._forced_check;
    }

    /**
     * Retrieves the name of the validator.
     * @returns {string} The name of the validator.
     */
    getValidatorName() {
        return 'ContainerEmptyValidator';
    }
}

export default ContainerEmptyValidator;
